// js/sections/recently-viewed-products.js
var __accessCheck = (obj, member, msg) => {
  if (!member.has(obj))
    throw TypeError("Cannot " + msg);
};
var __privateGet = (obj, member, getter) => {
  __accessCheck(obj, member, "read from private field");
  return getter ? getter.call(obj) : member.get(obj);
};
var __privateAdd = (obj, member, value) => {
  if (member.has(obj))
    throw TypeError("Cannot add the same private member more than once");
  member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
};
var __privateSet = (obj, member, value, setter) => {
  __accessCheck(obj, member, "write to private field");
  setter ? setter.call(obj, value) : member.set(obj, value);
  return value;
};
var __privateMethod = (obj, member, method) => {
  __accessCheck(obj, member, "access private method");
  return method;
};

// helper: extract section id from nearest .shopify-section
function extractSectionId(element) {
  element = element && element.classList && element.classList.contains("shopify-section") ? element : (element ? element.closest(".shopify-section") : null);
  return element && element.id ? element.id.replace("shopify-section-", "") : "";
}

var _isLoaded2, _searchQueryString, searchQueryString_get, _loadProducts, loadProducts_fn;

var RecentlyViewedProducts = class extends HTMLElement {
  constructor() {
    super(...arguments);
    __privateAdd(this, _searchQueryString);
    __privateAdd(this, _loadProducts);
    __privateAdd(this, _isLoaded2, false);
  }
  connectedCallback() {
    __privateMethod(this, _loadProducts, loadProducts_fn).call(this);
  }
};

_isLoaded2 = new WeakMap();
_searchQueryString = new WeakSet();

searchQueryString_get = function() {
  try {
    const raw = localStorage.getItem("theme:recently-viewed-products") || "[]";
    const arr = JSON.parse(raw);
    const items = new Set(Array.isArray(arr) ? arr : []);

    if (this.hasAttribute("exclude-id")) {
      const excludeRaw = this.getAttribute("exclude-id");
      const excludeId = Number(excludeRaw);
      if (!Number.isNaN(excludeId)) items.delete(excludeId); else items.delete(excludeRaw);
    }

    if (items.size === 0) return "";

    const attr = this.getAttribute("products-count");
    const attrLimit = attr ? parseInt(attr, 10) : NaN;
    const limit = Number.isFinite(attrLimit) && attrLimit > 0 ? attrLimit : items.size;

    return Array.from(items.values(), item => `id:${item}`).slice(0, limit).join(" OR ");
  } catch (err) {
    console.error("recently-viewed: query build error", err);
    return "";
  }
};

_loadProducts = new WeakSet();

loadProducts_fn = async function() {
  if (__privateGet(this, _isLoaded2)) return;
  __privateSet(this, _isLoaded2, true);

  try {
    const query = __privateGet(this, _searchQueryString, searchQueryString_get);
    if (!query) return;

    const section = this.closest(".shopify-section");
    if (!section) {
      console.warn("recently-viewed: parent .shopify-section not found");
      return;
    }

    const sectionId = extractSectionId(section);
    const url = `${Shopify.routes.root}search?type=product&q=${encodeURIComponent(query)}&section_id=${encodeURIComponent(sectionId)}`;

    const response = await fetch(url, { priority: "low" });
    if (!response.ok) {
      console.warn("recently-viewed: fetch failed", response.status);
      return;
    }

    const html = await response.text();
    const temp = new DOMParser().parseFromString(html, "text/html");
    const serverEl = temp.querySelector("recently-viewed-products");

    if (serverEl && serverEl.childElementCount > 0) {
      this.replaceChildren(...document.importNode(serverEl, true).childNodes);
      try { initRecentlyViewedSwipers(this); } catch (err) { console.warn("recently-viewed: swiper init failed", err); }
    } else {
      // section.remove(); // optional
    }
  } catch (err) {
    console.error("recently-viewed: loadProducts error", err);
  }
};

/**
 * Try to find an existing Swiper instance attached to element by common properties.
 * Checks:
 *  - el._recentlyViewedSwiper (our stored instance)
 *  - el.swiper or el.__swiper__ (common builds)
 *  - any property on el that looks like a Swiper instance (has .params)
 */
function findSwiperInstanceOnElement(el) {
  if (!el) return null;
  if (el._recentlyViewedSwiper) return el._recentlyViewedSwiper;
  if (el.swiper) return el.swiper;
  if (el.__swiper__) return el.__swiper__;
  // fallback: search element's own props for something that looks like swiper
  try {
    for (const key of Object.keys(el)) {
      const val = el[key];
      if (val && typeof val === 'object' && val.params && val.slideTo) {
        return val;
      }
    }
  } catch (e) {
    // ignore
  }
  return null;
}

/**
 * Initialize or bind Swiper instances for recently-viewed content.
 * root: Element or document
 */
function initRecentlyViewedSwipers(root) {
  if (!root) return;
  if (typeof Swiper === 'undefined') {
    console.warn('initRecentlyViewedSwipers: Swiper not found. Include Swiper JS to enable carousel.');
    return;
  }

  const containerRoot = root instanceof Element ? root : document;
  const containers = containerRoot.querySelectorAll('.recently-viewed-products-swiper');
  if (!containers || containers.length === 0) return;

  containers.forEach((container) => {
    // read identifiers (Liquid may render product empty -> handle gracefully)
    const productIdRaw = container.dataset.recentlyViewedSwiperProduct || "";
    const sectionIdRaw = container.dataset.recentlyViewedSwiperSection || "";
    // Some templates include an extra dash when productId is empty; prepare selectors both ways
    const prevSelectorCandidates = [
      `.recently-viewed-swiper-prev-${productIdRaw}-${sectionIdRaw}`,
      `.recently-viewed-swiper-prev-${sectionIdRaw}`,
      `.recently-viewed-swiper-prev--${sectionIdRaw}`
    ];
    const nextSelectorCandidates = [
      `.recently-viewed-swiper-next-${productIdRaw}-${sectionIdRaw}`,
      `.recently-viewed-swiper-next-${sectionIdRaw}`,
      `.recently-viewed-swiper-next--${sectionIdRaw}`
    ];

    let prevBtn = null, nextBtn = null;
    for (const s of prevSelectorCandidates) { prevBtn = document.querySelector(s); if (prevBtn) break; }
    for (const s of nextSelectorCandidates) { nextBtn = document.querySelector(s); if (nextBtn) break; }

    // optional slide hints
    const mobileSlidesAttr = parseFloat(container.dataset.mobileSlides);
    const desktopSlidesAttr = parseFloat(container.dataset.desktopSlides);
    const mobileSlides = Number.isFinite(mobileSlidesAttr) && mobileSlidesAttr > 0 ? mobileSlidesAttr : 1.225 ;
    const desktopSlides = Number.isFinite(desktopSlidesAttr) && desktopSlidesAttr > 0 ? desktopSlidesAttr : 4.625;

    console.log(desktopSlides,"desktopSlides");
    const swiperEl = container.classList.contains('swiper') ? container : (container.querySelector('.swiper') || container);
    if (!swiperEl) return;

    // Try to find existing instance
    const existing = findSwiperInstanceOnElement(swiperEl);

    // Count slides
    const slides = swiperEl.querySelectorAll('.swiper-slide');
    const slidesCount = slides ? slides.length : 0;
    if (slidesCount === 0) {
      container.style.display = 'none';
      return;
    }

  const mobileView = Math.min(Math.max(1, mobileSlides), slidesCount);
  const desktopView = Math.min(Math.max(1, desktopSlides), slidesCount);

    // helper to set nav visibility
    function setNavVisibility(inst) {
      const canSlide = inst && inst.slides && inst.params && inst.slides.length > inst.params.slidesPerView;
      if (prevBtn) prevBtn.style.display = canSlide ? '' : 'none';
      if (nextBtn) nextBtn.style.display = canSlide ? '' : 'none';
    }

    // Attach fallback click handlers (idempotent)
    function ensureFallbackClicks(el) {
      if (!el) return;
      if (el.dataset.rvBound) return;
      el.dataset.rvBound = '1';
      el.addEventListener('click', (e) => {
        const inst = findSwiperInstanceOnElement(swiperEl);
        if (inst && typeof inst.slidePrev === 'function' && el.className && el.className.indexOf('prev') !== -1) inst.slidePrev();
        if (inst && typeof inst.slideNext === 'function' && el.className && el.className.indexOf('next') !== -1) inst.slideNext();
      });
    }

    // If there's an existing instance, try to bind nav to it
    if (existing) {
      try {
        // prefer DOM elements for nav if available
        existing.params = existing.params || {};
        existing.params.navigation = existing.params.navigation || {};
        if (prevBtn) existing.params.navigation.prevEl = prevBtn;
        if (nextBtn) existing.params.navigation.nextEl = nextBtn;

        // re-initialize navigation if module exists
        if (existing.navigation && typeof existing.navigation.init === 'function') {
          existing.navigation.init();
          existing.navigation.update();
        } else {
          // try calling init on instance (some builds)
          try { existing.init && existing.init(); } catch (e) { /* ignore */ }
        }

        setNavVisibility(existing);
      } catch (err) {
        // ignore and fallback
        console.warn('recently-viewed: failed to rebind existing instance navigation', err);
      }

      // always add fallback click handlers
      ensureFallbackClicks(prevBtn);
      ensureFallbackClicks(nextBtn);
      return;
    }

    // No existing instance found — create new one safely
    try {
      // destroy any old reference we may have stored earlier
      if (swiperEl._recentlyViewedSwiper && typeof swiperEl._recentlyViewedSwiper.destroy === 'function') {
        try { swiperEl._recentlyViewedSwiper.destroy(true, true); } catch (e) { /* ignore */ }
        swiperEl._recentlyViewedSwiper = null;
      }

      const options = {
        slidesPerView: mobileView,
        loop: false,
        grabCursor: true,
        keyboard: { enabled: true, onlyInViewport: true },
        a11y: true,
        breakpoints: { 768: { slidesPerView: 3 }, 1024: {slidesPerView: desktopView} },
        navigation: {
          prevEl: prevBtn || prevSelectorCandidates[0],
          nextEl: nextBtn || nextSelectorCandidates[0]
        }
      };

      const instance = new Swiper(swiperEl, options);
      // store reference for later
      try { swiperEl._recentlyViewedSwiper = instance; } catch (e) { /* ignore */ }

      setNavVisibility(instance);
      ensureFallbackClicks(prevBtn);
      ensureFallbackClicks(nextBtn);
    } catch (err) {
      console.error('recently-viewed: failed to init swiper', err, container);
      // fallback: bind clicks so buttons at least do slidePrev/Next if instance appears later
      ensureFallbackClicks(prevBtn);
      ensureFallbackClicks(nextBtn);
      // poll for instance and attach nav when available
      const poll = setInterval(() => {
        const inst = findSwiperInstanceOnElement(swiperEl);
        if (inst) {
          try {
            if (prevBtn) inst.params = inst.params || {}, inst.params.navigation = inst.params.navigation || {}, inst.params.navigation.prevEl = prevBtn;
            if (nextBtn) inst.params.navigation.nextEl = nextBtn;
            if (inst.navigation && typeof inst.navigation.init === 'function') { inst.navigation.init(); inst.navigation.update(); }
            setNavVisibility(inst);
          } catch (e) { /* ignore */ }
          clearInterval(poll);
        }
      }, 250);
      setTimeout(() => clearInterval(poll), 5000);
    }
  });
}

function toggleRecentlyViewedNav(swiperInstance, prevBtn, nextBtn) {
  if (!swiperInstance) return;
  const canSlide = swiperInstance.slides.length > swiperInstance.params.slidesPerView;
  if (prevBtn) prevBtn.style.display = canSlide ? '' : 'none';
  if (nextBtn) nextBtn.style.display = canSlide ? '' : 'none';
}

if (!window.customElements.get("recently-viewed-products")) {
  window.customElements.define("recently-viewed-products", RecentlyViewedProducts);
}

export {
  RecentlyViewedProducts
}
